export const IssueBadge = ({ type, count }) => {
  const labels = {
    'lost-contact': 'LOST CONTACT',
    'reposition': 'REPOSITION',
    'expiring': 'EXPIRING B/P',
    'not-ready': 'NOT READY',
    'expired': 'EXPIRED B/P'
  };
  
  return (
    <span className={`badge ${type}`} data-testid={`badge-${type}`}>
      {labels[type]} {count}
    </span>
  );
};
